const colors = [
  {
    primaryColor: "#5D93E1",
    secondaryColor: "#689be3",
  },
  {
    primaryColor: "#5DC250",
    secondaryColor: "#85d17b",
  },
  {
    primaryColor: "#F9D288",
    secondaryColor: "#f6be55",
  },
  {
    primaryColor: "#F48687",
    secondaryColor: "#f05c5e",
  },
  {
    primaryColor: "#B964F7",
    secondaryColor: "#b355f6",
  },
];
export { colors };
